import slogo from 'assets/images/users/slogo.png';

// ==============================|| LOGO ICON (only image) ||============================== //

export default function LogoIcon() {
  return (
    <img
      src={slogo}
      alt="Social Media Hub Icon"
      style={{ width: 65, height: 45, borderRadius: '4px' }}
    />
  );
}
